import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Form, Field } from 'redux-form'
import Button from 'components/common/Button/Button'
import Input from './Input'
import { A } from 'components/common/Link/Link'
import toggle from 'components/common/hoc/toggle'
import Icon from 'components/common/Icon/Icon'

const ToggledApplyCouponFrom = ({
  handleSubmit,
  viewModel,
  submitting,
  expanded,
  toggleHandlers: { onClick }
}) =>
  <Wrapper>
    <ToggleLink bolder prevent handler={ onClick }>Apply Promo Code
      {
        expanded
          ? <Icon asset="caret-blue-down" margin="0 5px" />
          : <StyledIcon asset="caret-blue-right" margin="0 5px" />
      }
    </ToggleLink>
    {
      expanded && <StyledForm onSubmit={ handleSubmit }>
        <Field
          { ...viewModel.applyCoupon }
          component={ Input } />
        <AlignedButton data-at-apply-coupon-button disabled={ submitting }>Apply</AlignedButton>
      </StyledForm>
    }
  </Wrapper>

ToggledApplyCouponFrom.propTypes = {
  asyncValidating: PropTypes.bool,
  expanded: PropTypes.bool,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  }),
  viewModel: PropTypes.shape({
    applyCoupon: PropTypes.shape()
  })
}

export default toggle(ToggledApplyCouponFrom)

const Wrapper = styled.div`
  margin: 10px 0;
`

const AlignedButton = styled(Button)`
  float: right;
  width: 33%;
  margin-top: 5px;
`

const ToggleLink = styled(A)`
  font-weight: normal;
`

const StyledForm = styled(Form)`
  margin-top: 15px;
`

const StyledIcon = styled(Icon)`
  font-size: 11px;
  height: 10px;
  width: 10px;
`
